import { Typography } from '@mui/material';

type YoutubeStatsTooltipTimestampProps = {
  timestamp: string;
};

/**
 * Reusable timestamp label used across YouTube stats tooltip variants.
 */
export function YoutubeStatsTooltipTimestamp(props: YoutubeStatsTooltipTimestampProps) {
  const { timestamp } = props;

  return (
    <Typography variant="caption" sx={{ color: 'grey.300' }}>
      {timestamp}
    </Typography>
  );
}
